import { render, staticRenderFns } from "./account-created.vue?vue&type=template&id=2ba83e7c&scoped=true"
import script from "./account-created.vue?vue&type=script&lang=js"
export * from "./account-created.vue?vue&type=script&lang=js"
import style0 from "./account-created.vue?vue&type=style&index=0&id=2ba83e7c&prod&lang=css"
import style1 from "./account-created.vue?vue&type=style&index=1&id=2ba83e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba83e7c",
  null
  
)

export default component.exports